module.exports = {
      id: "info-solid-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#info-solid",
      toString: function () {
        return this.url;
      }
    }